import { configureStore } from "@reduxjs/toolkit";
import postsReducer from "../features/posts/postsSlice";
import postReducer from "../features/postDetails/postDetailsSlice";
import relatedPostsReducer from "../features/relatedPosts/relatedPostsSlice";
import sortReducer from "../features/sort/sortSlice";
import filterReducer from "../features/filter/filterSlice";
export const store = configureStore({
  reducer: {
    posts: postsReducer,
    post: postReducer,
    relatedPosts: relatedPostsReducer,
    sort: sortReducer,
    filter: filterReducer,
  },
});
